import { useEffect, useState } from 'react';

export const SM_UP_MQ = '(min-width: 640px)';

/** True at Tailwind `sm` breakpoint and above (640px). */
export function useIsSmUp() {
  const [isSmUp, setIsSmUp] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(SM_UP_MQ).matches : false
  );

  useEffect(() => {
    const mq = window.matchMedia(SM_UP_MQ);
    const update = () => setIsSmUp(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return isSmUp;
}
